import { FormBase } from 'core/components';

export default class CorporateContactEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'CORPORATE_CONTACT.EDIT.NAME',
                    placeholder: 'CORPORATE_CONTACT.EDIT.NAME_PLACEHOLDER',
                    type:'string',
                },
                   {
                    name: 'lastName',
                    label: 'CORPORATE_CONTACT.EDIT.LAST_NAME',
                    placeholder: 'CORPORATE_CONTACT.EDIT.LAST_NAME_PLACEHOLDER',
                    type:'string',
                },
                {
                    name: 'phone',
                    label: 'CORPORATE_CONTACT.EDIT.PHONE',
                    placeholder: 'CORPORATE_CONTACT.EDIT.PHONE_PLACEHOLDER',
                    type:'string'
                },
                {
                    name: 'email',
                    label: 'CORPORATE_CONTACT.EDIT.EMAIL',
                    placeholder: 'CORPORATE_CONTACT.EDIT.EMAIL_PLACEHOLDER',
                    rules:'email|string'
                },
                {
                    name: 'specialOrders',
                    type:'bool',
                    value: false,
                    label: 'Contact to approve special orders'
                },
                {
                    name: 'corporateId',
                    type:'string'
                },
                {
                    name: 'corporateContactDepartments',
                    label: 'FACILITY_ADDITIONAL_CONTACT.EDIT.DEPARTMENT',
                    placeholder: 'FACILITY_ADDITIONAL_CONTACT.EDIT.DEPARTMENT_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'position',
                    label: 'CORPORATE_CONTACT.EDIT.NOTE',
                    placeholder: 'CORPORATE_CONTACT.EDIT.NOTE',
                    type:'string'
                },
                { 
                    name: "overviewRecipientType", 
                    type: "text" 
                },
                { 
                    name: "docRequestRecipientType", 
                    type: "text" 
                },
                { 
                    name: "inventoryRecipientType", 
                    type: "text"
                },
                {
                    name: "pickTicketRecipientType", 
                    type: "text" 
                },
                {
                    name: "deliveryTicketType", 
                    type: "text" 
                }
            ],
        };
    }
}